import { globalText, marketplaceText } from "../../../../assets/texts";
import { type HeaderColumn } from "../../../../types/FilterTable";

export const headerColumns: HeaderColumn[] = [
  {
    label: marketplaceText.BILLING_ACCOUNT_ID,
    value: "data.billingAccountId",
    tooltip: marketplaceText.BILLING_ACCOUNT_ID,
    style: { align: "left", padding: "normal" },
  },
  {
    label: marketplaceText.CUSTOMER,
    value: "customer.data.primaryDomain",
    tooltip: marketplaceText.CUSTOMER,
    style: { align: "left", padding: "normal" },
  },
  {
    label: marketplaceText.ACCOUNT_ID,
    value: "ref.id",
    tooltip: marketplaceText.ACCOUNT_ID,
    style: { align: "left", padding: "normal" },
  },
  {
    label: marketplaceText.CREATE_TIME,
    value: "data.procurementAccount.createTime",
    tooltip: marketplaceText.CREATE_TIME,
    style: { align: "left", padding: "normal" },
  },
  {
    label: marketplaceText.LAST_UPDATE,
    value: "data.procurementAccount.updateTime",
    tooltip: marketplaceText.LAST_UPDATE,
    style: { align: "left", padding: "normal" },
  },
  {
    label: marketplaceText.STATE,
    value: "transform.state",
    tooltip: marketplaceText.STATE,
    style: { align: "left", padding: "normal" },
  },
  {
    value: "@",
    style: { align: "left", padding: "normal" },
  },
];

export const filterColumns = [
  {
    label: marketplaceText.BILLING_ACCOUNT_ID,
    path: "data.billingAccountId",
    comparators: ["==", "!="],
    toOption: (value) => ({
      value,
      label: value ?? globalText.NA,
    }),
  },
  {
    label: marketplaceText.CUSTOMER,
    path: "customer.data.primaryDomain",
    comparators: ["==", "!="],
    toOption: (value) => ({
      value,
      label: value ?? globalText.NA,
    }),
  },
  {
    label: marketplaceText.ACCOUNT_ID,
    path: "ref.id",
  },
  {
    label: marketplaceText.STATE,
    path: "transform.state",
    comparators: ["==", "!="],
  },
] as const;
